<template>
<!--  <DisplayScreen></DisplayScreen>-->
  <component :is="showComponent" ></component>
<!--
   <Play v-if="video_link === '' || video_link== null" key="old-display"></Play>

     <DisplayScreen v-else key="new-display"></DisplayScreen>

  <DisplayScreen></DisplayScreen>-->
</template>

<script>
import DisplayScreen from "@/views/display/DisplayScreen";
import Play from "@/views/display/Play";
import {mapActions, mapState} from "vuex";
export default {
  name: "MainApp",
  components: {DisplayScreen,Play},
  data () { return{
    video_link: "",
    component: "",

  }},

  methods: {
    subscribe(id){
      this.$pusher.subscribe("private-queue-" + id);
    },
    ...mapActions("Display", ["refresh"]),
    showLoading() {
      this.$vs.loading({
        container: "#checkin-box",
        scale: 0.6,
      });
    },
    hideLoading() {
      this.$vs.loading.close("#checkin-box > .con-vs-loading");
    },
  },
  computed: {
    ...mapState({
      kiosk_info: (state) => state.Display.display,
    }),
    showComponent: function(){
      let video_link = "";
      if (JSON.parse(this.kiosk_info.display.config).video_link) {
        video_link = JSON.parse(this.kiosk_info.display.config).video_link;
      }
      if ((video_link == "") || (video_link == null)){
        return 'Play';
      } else {
        return 'DisplayScreen';
      }
    },
  },
  created() {},
  mounted() {

  }

}
</script>

<style scoped>

</style>